import React, { useState } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";

const MailChimpForm = ({ theme }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();

    setSuccess(false);
    setError("");

    addToMailchimp(email)
      .then(data => {
        if (data.result === "success") {
          setSuccess(true);
        } else {
          setError(data.msg);
        }
      })
      .catch(error => {
        setError(error.message);
      });
  };

  const handleEmailChange = event => {
    setEmail(event.currentTarget.value);
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} className="mailchimpForm">
        <h3>Don't miss an episode!</h3>
        <div className="email-wrapper">
          {!!error && <span className="feedback error">{error}</span>}
          <input
            placeholder="Email address"
            name="email"
            type="email"
            onChange={handleEmailChange}
          />
          <button type="submit">Subscribe</button>
          {!!success && (
            <span className="feedback success">Thanks ! You'll receive a confirmation email.</span>
          )}
        </div>
      </form>

      <style jsx>
        {`
          .mailchimpForm {
            display: flex;
            flex-direction: column;

            color: #2a2a2a;
            padding: 10px;

            transition: all 0.7s linear;

            text-align: center;

            padding-top: 1.5rem;
            padding-bottom: 1.5rem;

            h3 {
              margin-top: 0;
              margin-bottom: 1rem;
              font-size: 1.1rem;
            }

            .Wrapper {
              display: flex;
              flex-direction: row;
            }

            input {
              color: #2a2a2a;
              width: 100%;
              border: 0;
              border-bottom: 1px solid #cdcdcd;
            }

            button,
            input {
              padding: 1rem 1.5rem;
              border-radius: 8px;
            }

            button {
              display: block;

              border: none;
              background-color: ${theme.background.color.brand};
              color: white;

              letter-spacing: 1px;
              transition: all 0.15s linear;
              margin: auto;
              margin-top: 10px;
              font-weight: bold;

              :hover {
                cursor: pointer;
                background: ${theme.color.brand.primaryActive};
              }
            }

            .feedback {
              display: block;
              padding-top: 10px;
              padding-bottom: 10px;

              font-size: 0.8rem;
              text-align: center;
            }

            .success {
              color: green;
            }

            .error {
              color: #dd0000;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default MailChimpForm;
